interface PermissionNoticeProps {
  action: string;
  requiredRole: string;
}

export default function PermissionNotice({
  action,
  requiredRole,
}: PermissionNoticeProps) {
  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
      <div className="flex items-center">
        <svg
          className="h-5 w-5 text-yellow-600 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>
        <p className="text-sm text-yellow-800">
          <span className="font-medium">{action}</span> 권한이 필요합니다. (
          {requiredRole} 이상) 관리자에게 문의하세요.
        </p>
      </div>
    </div>
  );
}
